<script setup lang="ts">
defineProps<{
  button: 'left' | 'right' | 'wheel'
}>()
</script>

<template>
  <svg class="mouse-glyph" viewBox="0 0 16 24" width="16" height="24" aria-hidden="true">
    <path
      v-if="button === 'left'"
      class="mouse-glyph__active"
      d="M8 1.5V9.5H1.5V8A6.5 6.5 0 0 1 8 1.5Z"
    />
    <path
      v-if="button === 'right'"
      class="mouse-glyph__active"
      d="M8 1.5V9.5H14.5V8A6.5 6.5 0 0 0 8 1.5Z"
    />
    <rect x="1.5" y="1.5" width="13" height="21" rx="6.5" class="mouse-glyph__outline" />
    <path d="M1.5 9.5H14.5M8 1.5V9.5" class="mouse-glyph__outline" />
    <rect
      v-if="button === 'wheel'"
      x="6.5"
      y="3.5"
      width="3"
      height="4.5"
      rx="1.5"
      class="mouse-glyph__active"
    />
  </svg>
</template>

<style scoped>
.mouse-glyph {
  flex-shrink: 0;
}

.mouse-glyph__outline {
  fill: none;
  stroke: rgba(0, 0, 0, 0.55);
  stroke-width: 1.3;
}

.mouse-glyph__active {
  fill: rgb(var(--v-theme-primary));
}
</style>
